import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Tarifrechner';

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: 'keywords', content: 'Tarifrechner, Wuerzburger, TravelSecure' },
      {
        name: 'description',
        content: 'Tarifrechner der Wuerzburger Versicherung',
      },
      { name: 'robots', content: 'noindex' },
    ]);
  }
}
